import axios from 'axios';
import { apiUrl, execUrl } from 'libs/commonVar';
import * as common from 'libs/commonFunc';

export const postRegisterAPI = params => common.requestRaw(apiUrl + 'Register', params, 'post');
export const checkPasswordAPI = params => common.requestRaw(apiUrl + 'Register/CheckPassword', params, 'get');

// function postRegisterAPI(paramDatas) {
//   return axios({
//     method: 'post',
//     url: apiUrl + 'Register',
//     data: {
//       userEmail: paramDatas.userEmail,
//       userPasswd: paramDatas.userPasswd,
//       userName: paramDatas.userName,
//       serviceName: paramDatas.serviceName
//     }
//   });
// }

// function checkPasswordAPI(paramDatas) {
//   return axios({
//     method: 'post',
//     url: apiUrl + 'Register/CheckPassword',
//     data: {
//       userEmailId: paramDatas.userEmail,
//       userPasswd: paramDatas.userPasswd
//     }
//   });
// }



// WEBPACK FOOTER //
// ./src/script/libs/registerLib.js